import { render, staticRenderFns } from "./social-list_h5.vue?vue&type=template&id=1aa7edeb&scoped=true&"
import script from "./social-list_h5.vue?vue&type=script&lang=js&"
export * from "./social-list_h5.vue?vue&type=script&lang=js&"
import style0 from "./social-list_h5.vue?vue&type=style&index=0&id=1aa7edeb&lang=less&scoped=true&"
import style1 from "./social-list_h5.vue?vue&type=style&index=1&id=1aa7edeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7edeb",
  null
  
)

export default component.exports